export interface Zelt {
  id: string;
  slug: string;
  name: string;
  marke: string;
  kategorie: ZeltKategorie;
  kurzbeschreibung: string;
  beschreibung: string;
  preis: number;
  originalPreis?: number;
  bilder: string[];
  personen: number;
  saison: 3 | 4;
  wassersaeule: number;
  gewicht: number;
  packmass: string;
  aufbauzeit: number;
  innenraum: string;
  hoehe: number;
  features: string[];
  vorteile: string[];
  nachteile: string[];
  bewertung: number;
  bewertungAnzahl: number;
  tags: ZeltTag[];
  verfuegbar: boolean;
}

export type ZeltKategorie =
  | "kuppelzelt"
  | "tunnelzelt"
  | "geodaet"
  | "tipi"
  | "wurfzelt"
  | "familienzelt"
  | "trekkingzelt"
  | "dachzelt";

export type ZeltTag = "neu" | "bestseller" | "sale" | "empfohlen" | "leicht" | "premium";

export const kategorien: { id: ZeltKategorie; name: string; beschreibung: string }[] = [
  { id: "kuppelzelt", name: "Kuppelzelte", beschreibung: "Klassische, freistehende Zelte mit gekreuzten Stangen" },
  { id: "tunnelzelt", name: "Tunnelzelte", beschreibung: "Geräumige Zelte mit parallelen Stangen" },
  { id: "geodaet", name: "Geodät-Zelte", beschreibung: "Extrem stabile Zelte für extreme Bedingungen" },
  { id: "tipi", name: "Tipi-Zelte", beschreibung: "Konische Zelte mit zentraler Stange" },
  { id: "wurfzelt", name: "Wurfzelte", beschreibung: "Pop-up Zelte für schnellen Aufbau" },
  { id: "familienzelt", name: "Familienzelte", beschreibung: "Große Zelte mit mehreren Kabinen" },
  { id: "trekkingzelt", name: "Trekkingzelte", beschreibung: "Leichte Zelte für Wanderungen" },
  { id: "dachzelt", name: "Dachzelte", beschreibung: "Autodachzelte für Camping auf dem Fahrzeugdach" },
];

export const zelte: Zelt[] = [
  {
    id: "1",
    slug: "alpine-pro-3",
    name: "Alpine Pro 3",
    marke: "BergFreund",
    kategorie: "kuppelzelt",
    kurzbeschreibung: "Robustes 3-Personen Kuppelzelt für anspruchsvolle Bergtouren",
    beschreibung: "Das Alpine Pro 3 ist der perfekte Begleiter für ambitionierte Bergsteiger und Trekking-Enthusiasten. Mit seiner robusten Konstruktion aus hochwertigem Ripstop-Nylon und verstärkten Nähten trotzt es selbst widrigsten Wetterbedingungen. Die zwei gegenüberliegenden Eingänge sorgen für optimale Belüftung und einfachen Zugang.",
    preis: 349,
    originalPreis: 429,
    bilder: [
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&h=600&fit=crop"
    ],
    personen: 3,
    saison: 4,
    wassersaeule: 5000,
    gewicht: 3.2,
    packmass: "48 x 18 cm",
    aufbauzeit: 8,
    innenraum: "210 x 180 cm",
    hoehe: 120,
    features: ["Silikon-beschichtetes Außenzelt", "Aluminium-Gestänge", "2 Apsiden", "Moskitonetz", "Innentaschen", "Lampenhalter"],
    vorteile: ["Extrem windstabil", "Schneller Aufbau", "Gute Belüftung", "Hochwertige Materialien"],
    nachteile: ["Etwas schwerer als Konkurrenzmodelle", "Premium-Preis"],
    bewertung: 4.8,
    bewertungAnzahl: 127,
    tags: ["bestseller", "empfohlen"],
    verfuegbar: true,
  },
  {
    id: "2",
    slug: "family-dome-6",
    name: "Family Dome 6",
    marke: "CampKing",
    kategorie: "familienzelt",
    kurzbeschreibung: "Geräumiges Familienzelt für bis zu 6 Personen mit separaten Schlafkabinen",
    beschreibung: "Das Family Dome 6 bietet Ihrer Familie den perfekten Rückzugsort in der Natur. Mit zwei separaten Schlafkabinen und einem großzügigen Wohnbereich haben alle genug Platz. Die Stehhöhe im Vorraum ermöglicht komfortables Bewegen, während die großen Fenster für ein luftiges Raumgefühl sorgen.",
    preis: 459,
    bilder: [
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1445308394109-4ec2920981b1?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571863533956-01c88e79957e?w=800&h=600&fit=crop"
    ],
    personen: 6,
    saison: 3,
    wassersaeule: 4000,
    gewicht: 12.5,
    packmass: "72 x 28 cm",
    aufbauzeit: 20,
    innenraum: "480 x 300 cm",
    hoehe: 195,
    features: ["2 Schlafkabinen", "Eingenähter Boden", "Große Fenster", "Vorraum mit Stehhöhe", "Kabeldurchführung", "Organizer-Taschen"],
    vorteile: ["Sehr geräumig", "Separate Schlafbereiche", "Stehhöhe", "Gutes Preis-Leistungs-Verhältnis"],
    nachteile: ["Schwer", "Längere Aufbauzeit", "Nicht für Trekking geeignet"],
    bewertung: 4.5,
    bewertungAnzahl: 89,
    tags: ["empfohlen"],
    verfuegbar: true,
  },
  {
    id: "3",
    slug: "ultralight-solo",
    name: "UltraLight Solo",
    marke: "TrekLite",
    kategorie: "trekkingzelt",
    kurzbeschreibung: "Ultraleichtes 1-Personen Zelt für Langstrecken-Wanderer",
    beschreibung: "Mit nur 980g ist das UltraLight Solo das perfekte Zelt für Thru-Hiker und alle, die jedes Gramm zählen. Das innovative Design nutzt Trekkingstöcke als Gestänge und spart so zusätzliches Gewicht. Trotz des minimalistischen Ansatzes bietet es zuverlässigen Schutz vor Wind und Regen.",
    preis: 289,
    bilder: [
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop"
    ],
    personen: 1,
    saison: 3,
    wassersaeule: 3000,
    gewicht: 0.98,
    packmass: "32 x 12 cm",
    aufbauzeit: 5,
    innenraum: "220 x 90 cm",
    hoehe: 95,
    features: ["DCF/Dyneema Material", "Trekkingstock-kompatibel", "Einwandig", "Reflektierende Abspannleinen", "Ultraleichte Heringe"],
    vorteile: ["Extrem leicht", "Kleines Packmaß", "Schneller Aufbau", "Ideal für Langstrecken"],
    nachteile: ["Nur für 1 Person", "Wenig Stauraum", "Kondensation möglich"],
    bewertung: 4.6,
    bewertungAnzahl: 234,
    tags: ["leicht", "bestseller"],
    verfuegbar: true,
  },
  {
    id: "4",
    slug: "expedition-geodat-4",
    name: "Expedition Geodät 4",
    marke: "PolarPro",
    kategorie: "geodaet",
    kurzbeschreibung: "Expeditions-taugliches Geodät-Zelt für extremste Bedingungen",
    beschreibung: "Das Expedition Geodät 4 wurde für die härtesten Bedingungen der Erde entwickelt. Ob Himalaya-Basiscamp oder Antarktis-Expedition - dieses Zelt hält stand. Die geodätische Konstruktion mit 5 Kreuzungspunkten bietet maximale Stabilität bei Sturm und Schneelast.",
    preis: 899,
    originalPreis: 1099,
    bilder: [
      "https://images.unsplash.com/photo-1571863533956-01c88e79957e?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop"
    ],
    personen: 4,
    saison: 4,
    wassersaeule: 10000,
    gewicht: 5.8,
    packmass: "58 x 22 cm",
    aufbauzeit: 15,
    innenraum: "240 x 220 cm",
    hoehe: 130,
    features: ["5-Punkt Geodät-Konstruktion", "Schneelappen", "Verstärkte Abspannpunkte", "Doppelwandig", "Belüftungsklappen", "Sturmleinen inklusive"],
    vorteile: ["Extrem windstabil", "Hohe Schneelast-Kapazität", "Langlebig", "Für extreme Bedingungen"],
    nachteile: ["Hoher Preis", "Schwerer als normale Zelte", "Komplexerer Aufbau"],
    bewertung: 4.9,
    bewertungAnzahl: 56,
    tags: ["premium", "empfohlen"],
    verfuegbar: true,
  },
  {
    id: "5",
    slug: "instant-pop-2",
    name: "Instant Pop 2",
    marke: "QuickCamp",
    kategorie: "wurfzelt",
    kurzbeschreibung: "Schnell aufbaubares Wurfzelt für 2 Personen",
    beschreibung: "Camping war noch nie so einfach! Das Instant Pop 2 ist in Sekunden aufgebaut - einfach aus der Tasche nehmen, in die Luft werfen und fertig. Perfekt für Festival-Besucher, spontane Wochenendtrips oder als Spielzelt für Kinder.",
    preis: 79,
    bilder: [
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1520095972714-909e91b038e5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop"
    ],
    personen: 2,
    saison: 3,
    wassersaeule: 2000,
    gewicht: 2.4,
    packmass: "80 cm Ø",
    aufbauzeit: 1,
    innenraum: "200 x 150 cm",
    hoehe: 110,
    features: ["Pop-up Mechanismus", "Integrierter Boden", "Belüftungsöffnungen", "Moskitonetz am Eingang", "Tragetasche"],
    vorteile: ["Sofort aufgebaut", "Günstiger Preis", "Ideal für Einsteiger", "Kein Werkzeug nötig"],
    nachteile: ["Großes Packmaß", "Weniger stabil bei Wind", "Nicht für schlechtes Wetter"],
    bewertung: 4.1,
    bewertungAnzahl: 312,
    tags: ["neu"],
    verfuegbar: true,
  },
  {
    id: "6",
    slug: "tunnel-comfort-4",
    name: "Tunnel Comfort 4",
    marke: "OutdoorPlus",
    kategorie: "tunnelzelt",
    kurzbeschreibung: "Komfortables Tunnelzelt mit großem Vorraum",
    beschreibung: "Das Tunnel Comfort 4 vereint cleveres Design mit hohem Wohnkomfort. Der große Vorraum bietet Platz für Campingmöbel und Ausrüstung, während die Schlafkabine mit verdunkelndem Material für erholsame Nächte sorgt. Die aerodynamische Form macht es auch bei Wind standfest.",
    preis: 329,
    bilder: [
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop"
    ],
    personen: 4,
    saison: 3,
    wassersaeule: 4500,
    gewicht: 8.2,
    packmass: "65 x 25 cm",
    aufbauzeit: 12,
    innenraum: "280 x 220 cm",
    hoehe: 175,
    features: ["Verdunkelte Schlafkabine", "Großer Vorraum", "Fiberglas-Gestänge", "Seitliche Belüftung", "Eingenähter Boden", "Regenschutz-Eingang"],
    vorteile: ["Viel Stauraum", "Gute Belüftung", "Verdunkelte Schlafkabine", "Stabiles Design"],
    nachteile: ["Braucht gutes Abspannen", "Mittelschwer"],
    bewertung: 4.4,
    bewertungAnzahl: 178,
    tags: [],
    verfuegbar: true,
  },
  {
    id: "7",
    slug: "tipi-adventure-8",
    name: "Tipi Adventure 8",
    marke: "NordicCamp",
    kategorie: "tipi",
    kurzbeschreibung: "Stilvolles Tipi-Zelt für bis zu 8 Personen",
    beschreibung: "Das Tipi Adventure 8 verbindet traditionelles Design mit moderner Funktionalität. Mit seinem charakteristischen konischen Design und der zentralen Stange bietet es ein einzigartiges Camping-Erlebnis. Die Rauchabzugsöffnung ermöglicht sogar die Nutzung eines kleinen Zeltofen.",
    preis: 549,
    bilder: [
      "https://images.unsplash.com/photo-1445308394109-4ec2920981b1?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571863533956-01c88e79957e?w=800&h=600&fit=crop"
    ],
    personen: 8,
    saison: 3,
    wassersaeule: 3500,
    gewicht: 9.5,
    packmass: "70 x 22 cm",
    aufbauzeit: 10,
    innenraum: "400 cm Ø",
    hoehe: 280,
    features: ["Zentrale Stange", "Rauchabzug", "Baumwoll-Mischgewebe", "Große Stehhöhe", "Rundum-Belüftung", "Zeltofen-kompatibel"],
    vorteile: ["Einzigartiges Ambiente", "Sehr hohe Stehhöhe", "Feuer/Ofen möglich", "Große Grundfläche"],
    nachteile: ["Zentrale Stange im Weg", "Kein separater Schlafbereich", "Schwerer"],
    bewertung: 4.3,
    bewertungAnzahl: 67,
    tags: [],
    verfuegbar: true,
  },
  {
    id: "8",
    slug: "compact-duo-2",
    name: "Compact Duo 2",
    marke: "BergFreund",
    kategorie: "kuppelzelt",
    kurzbeschreibung: "Kompaktes 2-Personen Kuppelzelt für Wochenendtouren",
    beschreibung: "Das Compact Duo 2 ist der ideale Begleiter für spontane Wochenendabenteuer. Kompakt, leicht und schnell aufgebaut - so macht Camping Spaß. Die reflektierenden Elemente sorgen für Sicherheit bei Dunkelheit.",
    preis: 159,
    originalPreis: 199,
    bilder: [
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&h=600&fit=crop"
    ],
    personen: 2,
    saison: 3,
    wassersaeule: 3000,
    gewicht: 2.8,
    packmass: "42 x 15 cm",
    aufbauzeit: 6,
    innenraum: "210 x 130 cm",
    hoehe: 100,
    features: ["Color-coded Clips", "Reflektierende Abspannleinen", "Mesh-Decke", "Innentaschen", "Leichtes Gestänge"],
    vorteile: ["Kompakt und leicht", "Einfacher Aufbau", "Guter Preis", "Zuverlässig"],
    nachteile: ["Nur 2 Personen", "Wenig Stauraum", "Keine Apsis"],
    bewertung: 4.2,
    bewertungAnzahl: 203,
    tags: ["sale"],
    verfuegbar: true,
  },
  {
    id: "9",
    slug: "storm-shield-3",
    name: "Storm Shield 3",
    marke: "PolarPro",
    kategorie: "geodaet",
    kurzbeschreibung: "Sturmfestes 3-Personen Zelt für widrige Bedingungen",
    beschreibung: "Wenn das Wetter unberechenbar wird, ist das Storm Shield 3 Ihr sicherer Hafen. Entwickelt und getestet in den schottischen Highlands, hält es selbst orkanaritgen Winden stand. Die verstärkte Struktur und die hochwertige Versiegelung machen es zum perfekten Partner für Outdoor-Enthusiasten.",
    preis: 599,
    bilder: [
      "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571863533956-01c88e79957e?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop"
    ],
    personen: 3,
    saison: 4,
    wassersaeule: 8000,
    gewicht: 4.5,
    packmass: "52 x 20 cm",
    aufbauzeit: 12,
    innenraum: "230 x 200 cm",
    hoehe: 115,
    features: ["DAC Featherlite Gestänge", "4 Abspannpunkte pro Seite", "Verstärkte Nähte", "Sturm-Ventile", "Schneefang", "Innenzelt aufhängbar"],
    vorteile: ["Extrem sturmfest", "Hochwertige Verarbeitung", "4-Jahreszeiten tauglich", "Leicht für Kategorie"],
    nachteile: ["Hoher Preis", "Nicht freistehend"],
    bewertung: 4.7,
    bewertungAnzahl: 89,
    tags: ["premium"],
    verfuegbar: true,
  },
  {
    id: "10",
    slug: "festival-fun-3",
    name: "Festival Fun 3",
    marke: "QuickCamp",
    kategorie: "wurfzelt",
    kurzbeschreibung: "Buntes Festival-Wurfzelt für 3 Personen",
    beschreibung: "Das Festival Fun 3 ist das perfekte Zelt für Festival-Gänger und Spontan-Camper. Mit seinem auffälligen Design finden Sie Ihr Zelt garantiert wieder! Der UV-Schutz 50+ schützt auch bei starker Sonne.",
    preis: 99,
    bilder: [
      "https://images.unsplash.com/photo-1520095972714-909e91b038e5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop"
    ],
    personen: 3,
    saison: 3,
    wassersaeule: 2500,
    gewicht: 3.1,
    packmass: "85 cm Ø",
    aufbauzeit: 1,
    innenraum: "210 x 180 cm",
    hoehe: 120,
    features: ["UV-Schutz 50+", "Buntes Design", "Pop-up Mechanismus", "Belüftungsklappen", "Innentaschen", "Tragetasche"],
    vorteile: ["Super schneller Aufbau", "Auffälliges Design", "UV-Schutz", "Preiswert"],
    nachteile: ["Großes Packmaß", "Nicht für schlechtes Wetter", "Weniger robust"],
    bewertung: 3.9,
    bewertungAnzahl: 456,
    tags: ["neu"],
    verfuegbar: true,
  },
  {
    id: "11",
    slug: "family-tunnel-5",
    name: "Family Tunnel 5",
    marke: "CampKing",
    kategorie: "familienzelt",
    kurzbeschreibung: "Familienfreundliches Tunnelzelt mit drei Kabinen",
    beschreibung: "Das Family Tunnel 5 ist das Traumzelt für Familien mit Kindern. Drei separate Schlafkabinen bieten Privatsphäre für Eltern und Kinder, während der zentrale Wohnbereich zum gemeinsamen Spielen und Essen einlädt. Die eingenähte Bodenplane hält Insekten und Feuchtigkeit draußen.",
    preis: 579,
    bilder: [
      "https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1445308394109-4ec2920981b1?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571863533956-01c88e79957e?w=800&h=600&fit=crop"
    ],
    personen: 5,
    saison: 3,
    wassersaeule: 4500,
    gewicht: 15.2,
    packmass: "78 x 32 cm",
    aufbauzeit: 25,
    innenraum: "520 x 300 cm",
    hoehe: 200,
    features: ["3 Schlafkabinen", "Eingenähte Bodenplane", "Klarsichtfenster", "Lampenaufhängung", "Kabeldurchführung", "Regendach über Eingang"],
    vorteile: ["3 separate Räume", "Volle Stehhöhe", "Sehr geräumig", "Familienfreundlich"],
    nachteile: ["Sehr schwer", "Lange Aufbauzeit", "Großes Packmaß"],
    bewertung: 4.6,
    bewertungAnzahl: 134,
    tags: ["bestseller"],
    verfuegbar: true,
  },
  {
    id: "12",
    slug: "minimalist-1",
    name: "Minimalist 1",
    marke: "TrekLite",
    kategorie: "trekkingzelt",
    kurzbeschreibung: "Das leichteste Einpersonenzelt am Markt",
    beschreibung: "Für Puristen und Gramm-Jäger: Das Minimalist 1 wiegt nur 680g und passt in jede Jackentasche. Das revolutionäre Design verzichtet auf alles Überflüssige und konzentriert sich auf das Wesentliche - einen trockenen Schlafplatz.",
    preis: 449,
    bilder: [
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop"
    ],
    personen: 1,
    saison: 3,
    wassersaeule: 2500,
    gewicht: 0.68,
    packmass: "25 x 10 cm",
    aufbauzeit: 4,
    innenraum: "200 x 85 cm",
    hoehe: 85,
    features: ["DCF/Cuben Fiber", "Nur 680g", "Single-Wall Design", "Trekkingstock-Aufbau", "Minimalistische Konstruktion"],
    vorteile: ["Ultraleicht", "Winziges Packmaß", "Schnellster Aufbau", "Ideal für Ultralight-Trekking"],
    nachteile: ["Sehr eng", "Teuer", "Nicht freistehend", "Kondensation"],
    bewertung: 4.4,
    bewertungAnzahl: 78,
    tags: ["leicht", "premium"],
    verfuegbar: true,
  },
  {
    id: "13",
    slug: "allround-4",
    name: "Allround 4",
    marke: "OutdoorPlus",
    kategorie: "kuppelzelt",
    kurzbeschreibung: "Vielseitiges Allround-Zelt für jede Gelegenheit",
    beschreibung: "Das Allround 4 macht seinem Namen alle Ehre: Ob Familienurlaub, Pfadfinderlager oder Trekkingtour - dieses Zelt meistert jede Herausforderung. Das bewährte Kuppeldesign kombiniert mit modernen Materialien ergibt ein zuverlässiges Zelt für alle Lebenslagen.",
    preis: 249,
    bilder: [
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop"
    ],
    personen: 4,
    saison: 3,
    wassersaeule: 3500,
    gewicht: 4.8,
    packmass: "55 x 18 cm",
    aufbauzeit: 10,
    innenraum: "240 x 210 cm",
    hoehe: 135,
    features: ["Freistehend", "2 Eingänge", "Belüftungshutzen", "Abspannmöglichkeiten", "Reparaturset inklusive"],
    vorteile: ["Vielseitig einsetzbar", "Gutes Preis-Leistungs-Verhältnis", "Freistehend", "Einfacher Aufbau"],
    nachteile: ["Keine besonderen Features", "Mittlere Qualität"],
    bewertung: 4.3,
    bewertungAnzahl: 267,
    tags: ["empfohlen"],
    verfuegbar: true,
  },
  {
    id: "14",
    slug: "winter-base-2",
    name: "Winter Base 2",
    marke: "PolarPro",
    kategorie: "geodaet",
    kurzbeschreibung: "Winterfestes 2-Personen Basislager-Zelt",
    beschreibung: "Das Winter Base 2 ist für echte Wintercamper konzipiert. Die verstärkte Konstruktion trägt hohe Schneelasten, während das spezielle Innenzelt-Material auch bei Minusgraden flexibel bleibt. Perfekt für Skitouren und Winter-Trekking.",
    preis: 749,
    bilder: [
      "https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571863533956-01c88e79957e?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop"
    ],
    personen: 2,
    saison: 4,
    wassersaeule: 10000,
    gewicht: 3.9,
    packmass: "48 x 18 cm",
    aufbauzeit: 10,
    innenraum: "200 x 130 cm",
    hoehe: 105,
    features: ["Frostresistentes Material", "Schneeschürze", "Verstärkte Gestängepunkte", "Innenzelt aufhängbar", "Reflektoren", "Belüftungssteuerung"],
    vorteile: ["Winterfest", "Hohe Schneelast-Kapazität", "Stabil", "Kompakt"],
    nachteile: ["Teuer", "Nur 2 Personen", "Etwas schwerer"],
    bewertung: 4.8,
    bewertungAnzahl: 45,
    tags: ["premium"],
    verfuegbar: true,
  },
  {
    id: "15",
    slug: "budget-basic-3",
    name: "Budget Basic 3",
    marke: "QuickCamp",
    kategorie: "kuppelzelt",
    kurzbeschreibung: "Preiswertes Einsteiger-Zelt für 3 Personen",
    beschreibung: "Camping muss nicht teuer sein! Das Budget Basic 3 bietet solide Qualität zum kleinen Preis. Ideal für Camping-Einsteiger, die nicht gleich viel investieren möchten, aber trotzdem zuverlässigen Schutz vor den Elementen erwarten.",
    preis: 69,
    bilder: [
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1520095972714-909e91b038e5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop"
    ],
    personen: 3,
    saison: 3,
    wassersaeule: 2000,
    gewicht: 3.5,
    packmass: "60 x 15 cm",
    aufbauzeit: 8,
    innenraum: "210 x 180 cm",
    hoehe: 115,
    features: ["Polyester-Außenzelt", "Fiberglas-Gestänge", "Moskitonetz", "Belüftungsöffnung", "Tragetasche"],
    vorteile: ["Sehr günstig", "Leicht", "Einfach aufzubauen", "Gut für Einsteiger"],
    nachteile: ["Einfache Materialien", "Weniger langlebig", "Nur für gutes Wetter"],
    bewertung: 3.8,
    bewertungAnzahl: 523,
    tags: ["sale"],
    verfuegbar: true,
  },
  // === DACHZELTE ===
  {
    id: "16",
    slug: "skycamp-3",
    name: "SkyCamp 3.0",
    marke: "iKamper",
    kategorie: "dachzelt",
    kurzbeschreibung: "Premium Hartschalen-Dachzelt für 3 Personen mit patentiertem Aufklappmechanismus",
    beschreibung: "Das iKamper SkyCamp 3.0 setzt Maßstäbe im Bereich der Hartschalen-Dachzelte. Dank des patentierten Aufklappmechanismus verwandelt sich die kompakte Dachbox in weniger als einer Minute in ein geräumiges Schlafzimmer für bis zu drei Personen. Die hochdichte Schaumstoffmatratze sorgt für erholsamen Schlaf, während die integrierte LED-Beleuchtung für angenehmes Ambiente sorgt. Die robuste Hartschale aus Glasfaser schützt zuverlässig vor Wind und Wetter und dient geschlossen als aerodynamische Dachbox. Universelle Montageschienen machen das SkyCamp 3.0 kompatibel mit nahezu allen gängigen Dachträgersystemen.",
    preis: 3499,
    originalPreis: 3899,
    bilder: [
      "https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1533745848184-3db07256e163?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1508739773434-c26b3d09e071?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1532339142463-fd0a8979791a?w=800&h=600&fit=crop"
    ],
    personen: 3,
    saison: 4,
    wassersaeule: 3000,
    gewicht: 62,
    packmass: "210 x 130 x 30 cm",
    aufbauzeit: 1,
    innenraum: "210 x 190 cm",
    hoehe: 100,
    features: ["Hartschalen-Konstruktion", "Patentierter Aufklappmechanismus", "Integrierte Matratze", "LED-Innenbeleuchtung", "Leiter inklusive", "Universelle Dachträgermontage"],
    vorteile: ["Blitzschneller Aufbau", "Wetterfest", "Bequeme Matratze", "Erhöht schlafen"],
    nachteile: ["Hoher Preis", "Schwer", "Beeinflusst Fahrzeugdynamik"],
    bewertung: 4.7,
    bewertungAnzahl: 89,
    tags: ["premium", "empfohlen"],
    verfuegbar: true,
  },
  {
    id: "17",
    slug: "adventure-dachzelt-140",
    name: "Adventure 140",
    marke: "Front Runner",
    kategorie: "dachzelt",
    kurzbeschreibung: "Kompaktes Softcover-Dachzelt für 2 Personen ideal für Geländefahrzeuge",
    beschreibung: "Das Front Runner Adventure 140 ist das ideale Dachzelt für Overlanding-Enthusiasten und Geländewagenfahrer. Das robuste Softcover-Design aus strapazierfähigem Ripstop-Polyester mit Aluminiumrahmen bietet einen optimalen Kompromiss aus Gewicht, Packmaß und Komfort. In nur fünf Minuten ist das Zelt aufgebaut und bietet eine großzügige Liegefläche für zwei Personen. Das umlaufende Moskitonetz hält Insekten fern, während die Teleskop-Leiter einen bequemen Einstieg ermöglicht. Die Quick-Release Befestigung erlaubt eine werkzeuglose Montage und Demontage am Dachträger.",
    preis: 1299,
    bilder: [
      "https://images.unsplash.com/photo-1563299796-17596ed6b017?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1517824806704-9040b037703b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1534187886935-1e1236e856c3?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1496545672447-f699b503d270?w=800&h=600&fit=crop"
    ],
    personen: 2,
    saison: 3,
    wassersaeule: 2500,
    gewicht: 45,
    packmass: "140 x 120 x 28 cm",
    aufbauzeit: 5,
    innenraum: "210 x 140 cm",
    hoehe: 95,
    features: ["Ripstop-Polyester", "Aluminiumrahmen", "Teleskop-Leiter", "Moskitonetz rundum", "Schuhablagentaschen", "Quick-Release Befestigung"],
    vorteile: ["Erschwinglich", "Leichter als Hartschale", "Schneller Aufbau", "Gute Belüftung"],
    nachteile: ["Nicht 4-Jahreszeiten", "Längerer Abbau als Hartschale", "Weniger isoliert"],
    bewertung: 4.3,
    bewertungAnzahl: 156,
    tags: ["bestseller"],
    verfuegbar: true,
  },
  {
    id: "18",
    slug: "horizon-dachzelt-xl",
    name: "Horizon XL",
    marke: "Thule",
    kategorie: "dachzelt",
    kurzbeschreibung: "Geräumiges Hartschalen-Dachzelt mit elektrischem Aufstellmechanismus",
    beschreibung: "Das Thule Horizon XL definiert Komfort auf dem Autodach neu. Per Knopfdruck öffnet der elektrische Aufstellmechanismus das Hartschalenzelt in wenigen Sekunden - ganz ohne manuelles Aufklappen oder Kurbeln. Die hochwertige Memory-Foam Matratze garantiert Schlafkomfort wie zu Hause, während integrierte USB-Ladeanschlüsse Ihre Geräte über Nacht aufladen. Das optionale Solarpanel auf der Hartschale macht Sie unabhängig von Landstrom. Der spezielle Verdunkelungsstoff im Inneren sorgt für erholsamen Schlaf auch bei Tageslicht, und das durchdachte Regenwasserablauf-System hält den Einstiegsbereich trocken.",
    preis: 4299,
    bilder: [
      "https://images.unsplash.com/photo-1532339142463-fd0a8979791a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1508739773434-c26b3d09e071?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=800&h=600&fit=crop"
    ],
    personen: 4,
    saison: 4,
    wassersaeule: 4000,
    gewicht: 75,
    packmass: "215 x 145 x 32 cm",
    aufbauzeit: 1,
    innenraum: "215 x 200 cm",
    hoehe: 110,
    features: ["Elektrischer Aufstellmechanismus", "Solarpanel-kompatibel", "Memory-Foam Matratze", "USB-Ladeanschlüsse", "Verdunkelungsstoff", "Regenwasserablauf-System"],
    vorteile: ["Elektrischer Aufbau per Knopfdruck", "Sehr geräumig", "Premium-Schlafkomfort", "Autark-fähig"],
    nachteile: ["Sehr teuer", "Sehr schwer", "Benötigt starke Dachträger"],
    bewertung: 4.9,
    bewertungAnzahl: 34,
    tags: ["premium", "neu"],
    verfuegbar: true,
  },
  {
    id: "19",
    slug: "campwerk-economy",
    name: "Economy Softcover",
    marke: "Campwerk",
    kategorie: "dachzelt",
    kurzbeschreibung: "Preiswertes Einsteiger-Dachzelt mit Klappfunktion",
    beschreibung: "Das Campwerk Economy Softcover ist der perfekte Einstieg in die Welt der Dachzelte, ohne das Budget zu sprengen. Das klappbare Softcover-Design aus robustem 600D Polyester bietet eine solide Grundausstattung zu einem unschlagbaren Preis. Die Aluminium-Bodenplatte sorgt für Stabilität, während die mitgelieferte Klapp-Leiter den Einstieg erleichtert. Das integrierte Regenverdeck schützt vor Niederschlag und die praktischen Innentaschen bieten Stauraum für Brille, Handy und Co. Die einfache Montage macht es auch für Dachzelt-Neulinge leicht, das Zelt auf dem Fahrzeug zu befestigen.",
    preis: 899,
    bilder: [
      "https://images.unsplash.com/photo-1563299796-17596ed6b017?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1533745848184-3db07256e163?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1517824806704-9040b037703b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop"
    ],
    personen: 2,
    saison: 3,
    wassersaeule: 2000,
    gewicht: 48,
    packmass: "143 x 122 x 30 cm",
    aufbauzeit: 3,
    innenraum: "200 x 140 cm",
    hoehe: 90,
    features: ["600D Polyester", "Aluminium-Bodenplatte", "Klapp-Leiter", "Regenverdeck", "Innentaschen", "Einfache Montage"],
    vorteile: ["Günstiger Einstiegspreis", "Solide Grundausstattung", "Einfache Installation", "Gutes Preis-Leistungs-Verhältnis"],
    nachteile: ["Einfachere Materialien", "Kein Premium-Komfort", "Weniger windstabil"],
    bewertung: 4.0,
    bewertungAnzahl: 212,
    tags: ["sale"],
    verfuegbar: true,
  },
  // === WEITERE ZELTE ===
  {
    id: "20",
    slug: "blackdeer-tunnel-6",
    name: "Expedition Tunnel 6",
    marke: "BlackDeer",
    kategorie: "tunnelzelt",
    kurzbeschreibung: "Geräumiges 6-Personen Tunnelzelt für ausgedehnte Campingurlaube",
    beschreibung: "Das BlackDeer Expedition Tunnel 6 ist ein beeindruckend geräumiges Tunnelzelt, das Platz für die ganze Familie bietet. Mit zwei separaten Schlafkabinen und einem großzügigen, begehbaren Wohnbereich in der Mitte fühlt sich Camping fast wie zu Hause an. Die drei stabilen Fiberglas-Bögen sorgen für eine solide Struktur, während das 4000mm Wassersäulen-Außenzelt zuverlässig vor Regen schützt. Große Mesh-Fenster an beiden Seiten garantieren eine hervorragende Durchlüftung auch an warmen Sommertagen. Die eingenähte Bodenplane im Wohnbereich hält Feuchtigkeit und Krabbeltiere draußen.",
    preis: 489,
    bilder: [
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1445308394109-4ec2920981b1?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571863533956-01c88e79957e?w=800&h=600&fit=crop"
    ],
    personen: 6,
    saison: 3,
    wassersaeule: 4000,
    gewicht: 14.8,
    packmass: "75 x 30 cm",
    aufbauzeit: 18,
    innenraum: "500 x 310 cm",
    hoehe: 195,
    features: ["2 Schlafkabinen", "Begehbarer Wohnbereich", "3 Fiberglas-Bögen", "Eingenähte Bodenplane", "Mesh-Fenster beidseitig", "Kabeldurchführung"],
    vorteile: ["Sehr geräumig", "Guter Preis für die Größe", "Gute Belüftung", "Stehhöhe im Wohnbereich"],
    nachteile: ["Schwer", "Längerer Aufbau", "Nur für Autocamping"],
    bewertung: 4.2,
    bewertungAnzahl: 93,
    tags: ["neu"],
    verfuegbar: true,
  },
  {
    id: "21",
    slug: "naturehike-cloud-2",
    name: "Cloud Up 2 Pro",
    marke: "Naturehike",
    kategorie: "trekkingzelt",
    kurzbeschreibung: "Ultraleichtes 2-Personen Trekkingzelt mit hervorragendem Packmaß",
    beschreibung: "Das Naturehike Cloud Up 2 Pro ist ein Meisterwerk minimalistischer Zeltbaukunst. Mit einem Gesamtgewicht von nur 1,5 kg gehört es zu den leichtesten doppelwandigen 2-Personen-Zelten auf dem Markt. Das 20D Silikon-beschichtete Nylon-Außenzelt in Kombination mit dem feinen Mesh-Innenzelt bietet optimalen Schutz bei minimalem Gewicht. Das Aluminiumgestänge lässt sich dank des Clip-Systems in wenigen Minuten aufbauen. Eine großzügige Apside bietet Platz für Rucksäcke und Schuhe. Ideal für Weitwanderer, Bikepacker und alle, die Wert auf jedes Gramm legen.",
    preis: 179,
    bilder: [
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&h=600&fit=crop"
    ],
    personen: 2,
    saison: 3,
    wassersaeule: 4000,
    gewicht: 1.5,
    packmass: "40 x 13 cm",
    aufbauzeit: 5,
    innenraum: "210 x 125 cm",
    hoehe: 100,
    features: ["20D Silikonbeschichtung", "7001 Aluminium-Gestänge", "Doppelwandig", "Clip-Aufbausystem", "Apside für Gepäck", "Y-Heringe inklusive"],
    vorteile: ["Extrem leicht", "Hervorragendes Packmaß", "Doppelwandig trotz geringem Gewicht", "Ausgezeichnetes Preis-Leistungs-Verhältnis"],
    nachteile: ["Etwas eng für 2 Personen", "Nur 1 Eingang", "Begrenzte Windstabilität"],
    bewertung: 4.5,
    bewertungAnzahl: 387,
    tags: ["leicht", "bestseller"],
    verfuegbar: true,
  },
  {
    id: "22",
    slug: "vaude-taurus-3",
    name: "Taurus 3P",
    marke: "Vaude",
    kategorie: "kuppelzelt",
    kurzbeschreibung: "Zuverlässiges 3-Personen Kuppelzelt mit nachhaltigem Green Shape Label",
    beschreibung: "Das Vaude Taurus 3P vereint bewährte Kuppelzelt-Technik mit dem Nachhaltigkeitsanspruch der Marke Vaude. Das umweltfreundlich hergestellte Zelt trägt das Green Shape Label und wird aus recycelten Materialien gefertigt. Das klassische Zwei-Bogen-Design ist freistehend und bietet zuverlässigen Schutz bei wechselhaftem Wetter. Die zwei Eingänge mit je einer Apside sorgen für bequemen Zugang und ausreichend Stauraum. Das gut durchdachte Belüftungssystem mit regulierbaren Ventilationsöffnungen minimiert Kondensation und sorgt für frische Luft im Inneren.",
    preis: 299,
    bilder: [
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&h=600&fit=crop"
    ],
    personen: 3,
    saison: 3,
    wassersaeule: 3000,
    gewicht: 3.6,
    packmass: "52 x 17 cm",
    aufbauzeit: 8,
    innenraum: "230 x 170 cm",
    hoehe: 115,
    features: ["Green Shape Label", "Recycelte Materialien", "2 Eingänge mit Apsiden", "Regulierbare Belüftung", "Freistehend", "Moskitonetz-Eingänge"],
    vorteile: ["Nachhaltig produziert", "Freistehend", "Zuverlässig bei Wind und Regen", "Gutes Raumangebot"],
    nachteile: ["Nicht für extreme Bedingungen", "Etwas höheres Gewicht in der Klasse", "Nur 3-Saison"],
    bewertung: 4.4,
    bewertungAnzahl: 198,
    tags: ["empfohlen"],
    verfuegbar: true,
  },
  {
    id: "23",
    slug: "outwell-montana-6sa",
    name: "Montana 6SA",
    marke: "Outwell",
    kategorie: "familienzelt",
    kurzbeschreibung: "Premium-Familienzelt mit innovativem Luftschlauch-Aufbausystem",
    beschreibung: "Das Outwell Montana 6SA revolutioniert den Zeltaufbau: Statt mühsam Stangen einzufädeln, pumpen Sie einfach die integrierten Luftschläuche auf - und das Zelt steht. Das Smart Air System macht den Aufbau zum Kinderspiel und ist in unter 10 Minuten erledigt. Das geräumige Familienzelt bietet drei separate Schlafkabinen, einen großzügigen Wohnbereich mit voller Stehhöhe und verdunkelte Schlafbereiche für erholsame Nächte. Die hochwertige Outtex-Beschichtung sorgt für zuverlässigen Wetterschutz, während große Panoramafenster ein helles, freundliches Raumgefühl schaffen.",
    preis: 799,
    originalPreis: 949,
    bilder: [
      "https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1445308394109-4ec2920981b1?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571863533956-01c88e79957e?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop"
    ],
    personen: 6,
    saison: 3,
    wassersaeule: 4000,
    gewicht: 22.5,
    packmass: "82 x 42 cm",
    aufbauzeit: 10,
    innenraum: "540 x 350 cm",
    hoehe: 210,
    features: ["Smart Air Aufbausystem", "3 Schlafkabinen", "Verdunkelte Schlafbereiche", "Panoramafenster", "Outtex-Beschichtung", "Eingenähter Boden"],
    vorteile: ["Revolutionärer Luftschlauch-Aufbau", "Verdunkelte Schlafkabinen", "Extrem geräumig", "Hochwertige Verarbeitung"],
    nachteile: ["Sehr schwer", "Großes Packmaß", "Hoher Preis"],
    bewertung: 4.6,
    bewertungAnzahl: 112,
    tags: ["premium"],
    verfuegbar: true,
  },
  {
    id: "24",
    slug: "robens-chinook-tipi",
    name: "Chinook Ursa",
    marke: "Robens",
    kategorie: "tipi",
    kurzbeschreibung: "Großes Baumwoll-Tipi für bis zu 10 Personen mit Zeltofen-Vorbereitung",
    beschreibung: "Das Robens Chinook Ursa ist ein beeindruckendes Baumwoll-Tipi, das den Geist der nordamerikanischen Ureinwohner mit modernem Camping-Komfort verbindet. Das atmungsaktive Polycotton-Gewebe reguliert das Innenklima auf natürliche Weise und reduziert Kondensation auf ein Minimum. Mit einem Durchmesser von über 4 Metern bietet es Platz für große Gruppen und Familien. Die verstärkte Ofenöffnung ermöglicht den sicheren Einsatz eines Zeltofens - perfekt für gemütliche Abende auch in der kalten Jahreszeit. Die zentrale Stange aus robustem Stahl ist in der Höhe verstellbar und sorgt für maximale Stabilität.",
    preis: 699,
    bilder: [
      "https://images.unsplash.com/photo-1445308394109-4ec2920981b1?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571863533956-01c88e79957e?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop"
    ],
    personen: 10,
    saison: 4,
    wassersaeule: 4000,
    gewicht: 18.5,
    packmass: "85 x 28 cm",
    aufbauzeit: 12,
    innenraum: "420 cm Ø",
    hoehe: 300,
    features: ["Polycotton-Gewebe", "Verstärkte Ofenöffnung", "Höhenverstellbare Zentralstange", "Belüftungsklappen", "Eingang mit Reißverschluss", "Sturmabspannung"],
    vorteile: ["Atmungsaktives Naturmaterial", "Zeltofen-fähig", "Riesiger Innenraum", "4-Jahreszeiten tauglich"],
    nachteile: ["Sehr schwer", "Aufbau erfordert Übung", "Teurer als Synthetik-Tipis"],
    bewertung: 4.5,
    bewertungAnzahl: 74,
    tags: ["premium"],
    verfuegbar: true,
  },
  {
    id: "25",
    slug: "quechua-2-seconds-easy",
    name: "2 Seconds Easy 3",
    marke: "Quechua",
    kategorie: "wurfzelt",
    kurzbeschreibung: "Verbessertes Wurfzelt mit Fresh&Black Verdunkelungstechnologie",
    beschreibung: "Das Quechua 2 Seconds Easy 3 setzt die Erfolgsgeschichte der legendären 2-Seconds-Serie fort und bringt entscheidende Verbesserungen mit. Die patentierte Fresh&Black Technologie blockt bis zu 99% des Lichts und reduziert die Aufheizung im Inneren um bis zu 17°C - perfekt für Festival-Camping oder Sommernächte. Der verbesserte Aufklappmechanismus macht nicht nur den Aufbau, sondern erstmals auch den Abbau kinderleicht: Einfach an den markierten Schlaufen ziehen und das Zelt faltet sich wie von selbst zusammen. Die erhöhte Wassersäule von 2500mm bietet zuverlässigen Regenschutz für spontane Camping-Abenteuer.",
    preis: 129,
    bilder: [
      "https://images.unsplash.com/photo-1520095972714-909e91b038e5?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop"
    ],
    personen: 3,
    saison: 3,
    wassersaeule: 2500,
    gewicht: 4.3,
    packmass: "82 cm Ø",
    aufbauzeit: 1,
    innenraum: "210 x 180 cm",
    hoehe: 118,
    features: ["Fresh&Black Technologie", "Verbesserter Pop-up Mechanismus", "Easy-Fold Abbausystem", "UV-Schutz 50+", "Belüftungsöffnungen", "Innentaschen"],
    vorteile: ["Aufbau in 2 Sekunden", "Verdunkelung und Kühlung", "Einfacher Abbau", "Bewährte Qualität"],
    nachteile: ["Großes Packmaß", "Nicht für schlechtes Wetter", "Schwerer als klassische Wurfzelte"],
    bewertung: 4.4,
    bewertungAnzahl: 645,
    tags: ["bestseller"],
    verfuegbar: true,
  },
  {
    id: "26",
    slug: "hilleberg-nallo-3",
    name: "Nallo 3",
    marke: "Hilleberg",
    kategorie: "tunnelzelt",
    kurzbeschreibung: "Hochwertiges Expeditions-Tunnelzelt für 3 Personen aus schwedischer Manufaktur",
    beschreibung: "Das Hilleberg Nallo 3 verkörpert die kompromisslose Qualitätsphilosophie der schwedischen Zeltmanufaktur. Als Tunnelzelt der Black Label Serie ist es für den ganzjährigen Einsatz unter härtesten Bedingungen konzipiert. Das Kerlon 1800 Außenzelt mit 3-facher Silikonbeschichtung bietet eine Wassersäule von 5000mm bei minimalem Gewicht. Das durchdachte Gestängesystem mit 10mm DAC Featherlite NSL Stangen sorgt für außergewöhnliche Stabilität bei Wind und Schnee. Zwei gegenüberliegende Eingänge mit großzügigen Apsiden bieten komfortablen Zugang und reichlich Stauraum. In Schweden handgefertigt und mit lebenslanger Garantie.",
    preis: 1099,
    bilder: [
      "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571863533956-01c88e79957e?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop"
    ],
    personen: 3,
    saison: 4,
    wassersaeule: 5000,
    gewicht: 2.8,
    packmass: "50 x 20 cm",
    aufbauzeit: 5,
    innenraum: "220 x 170 cm",
    hoehe: 105,
    features: ["Kerlon 1800 Außenzelt", "DAC Featherlite NSL Gestänge", "2 Eingänge mit Apsiden", "Simultanaufbau Innen-/Außenzelt", "Handgefertigt in Schweden", "Lebenslange Garantie"],
    vorteile: ["Kompromisslose Qualität", "Extrem leicht für 4-Saison", "Hervorragende Windstabilität", "Simultaner Aufbau"],
    nachteile: ["Sehr hoher Preis", "Muss abgespannt werden", "Schlichte Optik"],
    bewertung: 4.9,
    bewertungAnzahl: 62,
    tags: ["premium"],
    verfuegbar: true,
  },
  {
    id: "27",
    slug: "msr-hubba-hubba-2",
    name: "Hubba Hubba NX 2",
    marke: "MSR",
    kategorie: "trekkingzelt",
    kurzbeschreibung: "Legendäres ultraleichtes 2-Personen Trekkingzelt mit durchdachtem Design",
    beschreibung: "Das MSR Hubba Hubba NX 2 ist eine Ikone unter den Trekkingzelten und hat seit seiner Einführung unzählige Auszeichnungen erhalten. Das Unified Hub Design vereinfacht den Aufbau auf wenige Handgriffe, während das symmetrische Design zwei gleichwertige Eingänge und Vestibüle bietet. Das Micromesh-Innenzelt sorgt für optimale Belüftung und hält gleichzeitig auch kleinste Insekten fern. Mit nur 1,72 kg ist es leicht genug für ausgedehnte Trekkingtouren, bietet dabei aber genug Platz für zwei Personen und deren Ausrüstung. Die Xtreme Shield Beschichtung schützt zuverlässig vor UV-Strahlung und verlängert die Lebensdauer des Materials erheblich.",
    preis: 449,
    bilder: [
      "https://images.unsplash.com/photo-1510312305653-8ed496efae75?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1537905569824-f89f14cceb68?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1571863533956-01c88e79957e?w=800&h=600&fit=crop"
    ],
    personen: 2,
    saison: 3,
    wassersaeule: 3000,
    gewicht: 1.72,
    packmass: "46 x 15 cm",
    aufbauzeit: 4,
    innenraum: "213 x 127 cm",
    hoehe: 100,
    features: ["Unified Hub Design", "Xtreme Shield Beschichtung", "Micromesh-Innenzelt", "2 Eingänge und Vestibüle", "DAC NFL Gestänge", "Farbcodierte Clips"],
    vorteile: ["Bewährtes ikonisches Design", "Sehr leicht", "2 gleichwertige Eingänge", "Freistehend"],
    nachteile: ["Premium-Preis", "Nur 3-Saison", "Etwas eng bei schlechtem Wetter"],
    bewertung: 4.7,
    bewertungAnzahl: 421,
    tags: ["empfohlen", "leicht"],
    verfuegbar: true,
  },
  {
    id: "28",
    slug: "glamping-safari-deluxe",
    name: "Safari Deluxe",
    marke: "GlampLux",
    kategorie: "familienzelt",
    kurzbeschreibung: "Luxuriöses Glamping-Zelt im Safari-Stil für ultimativen Outdoor-Komfort",
    beschreibung: "Das GlampLux Safari Deluxe definiert Camping neu und verbindet den Charme afrikanischer Safari-Lodges mit modernem Outdoor-Komfort. Die robuste Konstruktion aus 320g/m² Baumwoll-Canvas sorgt für ein natürliches Raumklima – im Sommer angenehm kühl, in kühlen Nächten wärmend. Mit einer Grundfläche von 5 x 4 Metern und einer durchgehenden Stehhöhe von 2,50 Metern bietet das Safari Deluxe ein echtes Wohngefühl unter freiem Himmel. Die großen Panoramafenster mit Moskitonetzen lassen Licht und Luft herein und halten Insekten draußen. Die geräumige Veranda mit Vordach schafft einen geschützten Außenbereich zum Entspannen und Genießen. Der eingenähte Boden hält Feuchtigkeit und Krabbeltiere zuverlässig fern, während die Zeltofen-Öffnung auch in der kühleren Jahreszeit gemütliches Camping ermöglicht. Ob als luxuriöser Rückzugsort im eigenen Garten, als Highlight auf einem Glamping-Platz oder als komfortable Unterkunft für Festivals – das Safari Deluxe macht jedes Outdoor-Abenteuer zum besonderen Erlebnis.",
    preis: 1299,
    originalPreis: 1499,
    bilder: [
      "https://images.unsplash.com/photo-1499363536502-87642509e31b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1517823382935-51bfcb0ec6bc?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1445308394109-4ec2920981b1?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1534187886935-1e1236e856c3?w=800&h=600&fit=crop"
    ],
    personen: 6,
    saison: 3,
    wassersaeule: 3500,
    gewicht: 35,
    packmass: "90 x 35 cm",
    aufbauzeit: 30,
    innenraum: "500 x 400 cm",
    hoehe: 250,
    features: ["Baumwoll-Canvas", "Vollständige Stehhöhe", "Veranda mit Vordach", "Große Panoramafenster", "Eingenähter Boden", "Zeltofen-kompatibel"],
    vorteile: ["Luxuriöses Raumgefühl", "Atmungsaktives Naturmaterial", "Volle Stehhöhe überall", "Stilvolles Safari-Design"],
    nachteile: ["Sehr schwer", "Lange Aufbauzeit", "Teurer als Standardzelte", "Nur für stationäres Camping"],
    bewertung: 4.6,
    bewertungAnzahl: 67,
    tags: ["premium", "neu"],
    verfuegbar: true,
  },
  {
    id: "29",
    slug: "emperor-bell-tent",
    name: "Emperor Bell 5m",
    marke: "CanvasCamp",
    kategorie: "tipi",
    kurzbeschreibung: "Hochwertiges Baumwoll-Glockenzelt mit 5m Durchmesser für stilvolles Glamping",
    beschreibung: "Das CanvasCamp Emperor Bell 5m ist ein klassisches Glockenzelt, das mit seiner zeitlosen Eleganz und handwerklichen Qualität begeistert. Aus schwerem 285g/m² Baumwollstoff gefertigt, reguliert es die Innentemperatur auf natürliche Weise und sorgt für ein angenehmes Klima bei jeder Witterung. Die charakteristische Kegelform mit zentraler Stahlstange erzeugt einen beeindruckenden Innenraum von 5 Metern Durchmesser mit einer Scheitelhöhe von 3 Metern – genug Platz für eine komplette Wohneinrichtung. Die umlaufenden Mesh-Fenster mit aufrollbaren Abdeckungen ermöglichen eine flexible Belüftung und bieten Panoramablick auf die Umgebung. Die mitgelieferte, herausnehmbare Bodenplane schützt vor Bodenfeuchtigkeit und lässt sich bei Bedarf zum Reinigen entfernen. Ob als stilvolle Gartenlounge, romantische Hochzeitsdekoration, gemütliches Festival-Zuhause oder dauerhaftes Glamping-Quartier – das Emperor Bell vereint Tradition und Komfort auf einzigartige Weise. Die natürliche Baumwolle wird mit jeder Befeuchtung dichter und entwickelt über die Jahre eine charakteristische Patina.",
    preis: 849,
    bilder: [
      "https://images.unsplash.com/photo-1520101244246-293f77ffc39e?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1533632359083-0185df1be6d8?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1496545672447-f699b503d270?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1478827536114-da961b7f86d2?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1508739773434-c26b3d09e071?w=800&h=600&fit=crop"
    ],
    personen: 8,
    saison: 3,
    wassersaeule: 3000,
    gewicht: 28,
    packmass: "80 x 30 cm",
    aufbauzeit: 15,
    innenraum: "500 cm Ø",
    hoehe: 300,
    features: ["285g/m² Baumwolle", "Zentralstange aus Stahl", "Reißverschluss-Eingang", "Mesh-Fenster mit Rollos", "Bodenplane inklusive", "Regenwasserschutz"],
    vorteile: ["Elegantes klassisches Design", "Natürliches Raumklima", "Großer Innenraum", "Vielseitig einsetzbar"],
    nachteile: ["Schwer und großes Packmaß", "Baumwolle braucht Pflege", "Lange Trocknungszeit"],
    bewertung: 4.5,
    bewertungAnzahl: 134,
    tags: ["empfohlen"],
    verfuegbar: true,
  },
  {
    id: "30",
    slug: "vango-airbeam-6",
    name: "AirBeam Exceed 6",
    marke: "Vango",
    kategorie: "familienzelt",
    kurzbeschreibung: "Innovatives aufblasbares Familienzelt mit AirBeam-Technologie für mühelosen Aufbau",
    beschreibung: "Das Vango AirBeam Exceed 6 revolutioniert den Familienurlaub mit seiner bahnbrechenden Luftschlauch-Technologie. Statt herkömmlicher Stangen sorgen robuste, aufblasbare AirBeam-Schläuche für die Struktur – ein einziger Pumpenansatz genügt, um alle Schläuche nacheinander aufzupumpen und das Zelt in nur 8 Minuten aufzubauen. Das ist besonders praktisch, wenn ungeduldige Kinder auf den Campingplatz drängen. Drei separate Schlafkabinen mit verdunkeltem Innenstoff (Nightfall-Technologie) sorgen für erholsamen Schlaf auch bei frühem Sonnenaufgang. Der großzügige Wohnbereich mit 205 cm Stehhöhe bietet Platz für einen Campingtisch und Stühle, während die großen Fenster den Raum hell und einladend gestalten. Der vollständig eingenähte Boden schützt zuverlässig vor Feuchtigkeit, Zugluft und Insekten. Mit einer Wassersäule von 4000 mm hält das AirBeam Exceed auch starkem Regen problemlos stand. Die bruchsichere Konstruktion ist zudem ein großer Vorteil bei stürmischem Wetter – wo herkömmliche Stangen brechen können, geben die Luftschläuche bei Böen flexibel nach und kehren sofort in ihre Form zurück.",
    preis: 699,
    originalPreis: 849,
    bilder: [
      "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1525811902-f2342640856e?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1508873696983-2dfd5898f08b?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1464207687429-7505649dae38?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1532339142463-fd0a8979791a?w=800&h=600&fit=crop"
    ],
    personen: 6,
    saison: 3,
    wassersaeule: 4000,
    gewicht: 18.5,
    packmass: "76 x 38 cm",
    aufbauzeit: 8,
    innenraum: "480 x 320 cm",
    hoehe: 205,
    features: ["AirBeam Luftschlauch-Technologie", "Einzelne Pumpe für alle Schläuche", "3 Schlafkabinen", "Verdunkelte Schlafbereiche", "Eingenähter Boden", "Große Fenster"],
    vorteile: ["Keine Stangen nötig", "Aufbau in 8 Minuten", "Bruchsichere Konstruktion", "Familienfreundlich"],
    nachteile: ["Pumpe erforderlich", "Luftverlust möglich", "Schwerer als Stangenversion"],
    bewertung: 4.3,
    bewertungAnzahl: 189,
    tags: ["neu", "empfohlen"],
    verfuegbar: true,
  },
  {
    id: "31",
    slug: "coleman-sundome-4",
    name: "Sundome 4",
    marke: "Coleman",
    kategorie: "kuppelzelt",
    kurzbeschreibung: "Bewährtes Einsteiger-Campingzelt für 4 Personen zum kleinen Preis",
    beschreibung: "Das Coleman Sundome 4 ist der ideale Einstieg in die Welt des Campings und beweist, dass zuverlässige Qualität nicht teuer sein muss. Seit Jahren gehört es zu den meistverkauften Zelten weltweit – und das aus gutem Grund. Das patentierte WeatherTec-System mit invertierten Nähten und geschweißten Bodenecken hält Regenwasser zuverlässig draußen. Der Aufbau gelingt auch Anfängern in nur 10 Minuten dank des einfachen, farbcodierten Stangensystems. Die großen Mesh-Belüftungspanels im Dach sorgen für eine gute Luftzirkulation und reduzieren Kondenswasser in kühlen Nächten. Praktische Details wie Innentaschen für Handy, Brille und Taschenlampe sowie eine Stromkabel-Durchführung für den Campingplatz machen den Alltag im Zelt angenehm. Mit 240 x 210 cm Grundfläche bietet das Sundome ausreichend Platz für vier Personen oder gemütlichen Raum für zwei Personen mit Gepäck. Das kompakte Packmaß und das geringe Gewicht von 4,2 kg machen es zum unkomplizierten Begleiter für Wochenendausflüge, Festivals und Campingurlaube. Coleman gewährt auf das Sundome eine 2-Jahres-Garantie.",
    preis: 89,
    bilder: [
      "https://images.unsplash.com/photo-1563299796-17596ed6b017?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1483381616603-8dde934da56f?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1476041800959-2f6bb412c8ce?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1529408570655-18d036ce978e?w=800&h=600&fit=crop"
    ],
    personen: 4,
    saison: 3,
    wassersaeule: 2000,
    gewicht: 4.2,
    packmass: "58 x 18 cm",
    aufbauzeit: 10,
    innenraum: "240 x 210 cm",
    hoehe: 130,
    features: ["WeatherTec-System", "Invertierte Nähte", "Mesh-Belüftung", "Stromkabel-Durchführung", "Innentaschen", "Tragetasche"],
    vorteile: ["Sehr günstiger Preis", "Einfacher Aufbau", "Bewährte Coleman-Qualität", "Ideal für Einsteiger"],
    nachteile: ["Einfache Materialien", "Begrenzte Windstabilität", "Wenig Stauraum"],
    bewertung: 4.0,
    bewertungAnzahl: 876,
    tags: ["sale", "bestseller"],
    verfuegbar: true,
  },
];

export function getZeltBySlug(slug: string): Zelt | undefined {
  return zelte.find(z => z.slug === slug);
}

export function getZeltById(id: string): Zelt | undefined {
  return zelte.find(z => z.id === id);
}

export type FinderEinsatz = "camping" | "trekking" | "festival" | "winter" | "auto";
export type FinderBudget = "unter-150" | "150-400" | "400-plus";
export type FinderPrioritaet = "gewicht" | "komfort" | "preis" | "wetter";

export interface FinderAnswers {
  personen: number;
  einsatz: FinderEinsatz;
  budget: FinderBudget;
  prioritaet: FinderPrioritaet;
}

export interface FinderResult {
  zelt: Zelt;
  score: number;
  gruende: string[];
}

export const FINDER_EINSATZ = ["camping", "trekking", "festival", "winter", "auto"] as const;
export const FINDER_BUDGET = ["unter-150", "150-400", "400-plus"] as const;
export const FINDER_PRIORITAET = ["gewicht", "komfort", "preis", "wetter"] as const;

function matchesSuche(z: Zelt, query: string): boolean {
  const q = query.toLowerCase().trim();
  if (q.length < 2) return true;
  const haystack = [
    z.name,
    z.marke,
    z.beschreibung,
    z.kurzbeschreibung,
    z.kategorie,
    ...z.features,
    ...z.tags,
    ...z.vorteile,
  ].join(" ").toLowerCase();
  return haystack.includes(q);
}

export function sucheZelte(query: string): Zelt[] {
  const q = query.toLowerCase().trim();
  if (q.length < 2) return [];
  return zelte.filter(z => matchesSuche(z, q));
}

export function getMarken(): string[] {
  return [...new Set(zelte.map(z => z.marke))].sort((a, b) => a.localeCompare(b, "de"));
}

export function filterZelte(options: {
  kategorie?: ZeltKategorie;
  personen?: number;
  saison?: 3 | 4;
  minPreis?: number;
  maxPreis?: number;
  tags?: ZeltTag[];
  suche?: string;
  marke?: string;
  maxGewicht?: number;
  minWassersaeule?: number;
}): Zelt[] {
  return zelte.filter(z => {
    if (options.kategorie && z.kategorie !== options.kategorie) return false;
    if (options.personen && z.personen < options.personen) return false;
    if (options.saison && z.saison < options.saison) return false;
    if (options.minPreis && z.preis < options.minPreis) return false;
    if (options.maxPreis && z.preis > options.maxPreis) return false;
    if (options.tags && options.tags.length > 0) {
      if (!options.tags.some(tag => z.tags.includes(tag))) return false;
    }
    if (options.suche && !matchesSuche(z, options.suche)) return false;
    if (options.marke && z.marke.toLowerCase() !== options.marke.toLowerCase()) return false;
    if (options.maxGewicht && z.gewicht > options.maxGewicht) return false;
    if (options.minWassersaeule && z.wassersaeule < options.minWassersaeule) return false;
    return true;
  });
}

export function findeZelte(answers: FinderAnswers, limit = 6): FinderResult[] {
  const budgetMax = answers.budget === "unter-150" ? 150 : answers.budget === "150-400" ? 400 : Infinity;
  const budgetMin = answers.budget === "unter-150" ? 0 : answers.budget === "150-400" ? 150 : 400;

  return zelte
    .filter(z => {
      if (z.personen < answers.personen) return false;
      if (answers.einsatz === "auto" && z.kategorie !== "dachzelt") return false;
      return true;
    })
    .map(z => {
      let score = 0;
      const gruende: string[] = [];

      if (z.personen === answers.personen) {
        score += 6;
        gruende.push(`Genau für ${answers.personen} Person${answers.personen === 1 ? "" : "en"}`);
      } else if (z.personen === answers.personen + 1) {
        score += 3;
        gruende.push("Etwas mehr Platz als nötig");
      } else {
        score += 1;
      }

      switch (answers.einsatz) {
        case "camping":
          if (z.kategorie === "familienzelt" || z.kategorie === "tunnelzelt") {
            score += 5;
            gruende.push("Ideal für Campingplätze");
          } else if (z.kategorie === "kuppelzelt") {
            score += 3;
            gruende.push("Solides Campingzelt");
          }
          if (z.hoehe >= 160) {
            score += 2;
            gruende.push("Stehhöhe im Innenraum");
          }
          break;
        case "trekking":
          if (z.kategorie === "trekkingzelt") {
            score += 6;
            gruende.push("Speziell für Trekking");
          }
          if (z.tags.includes("leicht") || z.gewicht <= 2.2) {
            score += 4;
            gruende.push("Leicht im Rucksack");
          }
          if (z.gewicht <= 1.5) {
            score += 2;
            gruende.push("Ultraleicht");
          }
          break;
        case "festival":
          if (z.kategorie === "wurfzelt") {
            score += 6;
            gruende.push("Blitzschneller Aufbau");
          }
          if (z.aufbauzeit <= 8) {
            score += 3;
            gruende.push(`Aufgebaut in ${z.aufbauzeit} Minuten`);
          }
          if (z.preis <= 180) {
            score += 2;
            gruende.push("Festival-tauglicher Preis");
          }
          break;
        case "winter":
          if (z.saison === 4) {
            score += 6;
            gruende.push("4-Saison-tauglich");
          }
          if (z.kategorie === "geodaet") {
            score += 4;
            gruende.push("Extrem windstabil");
          }
          if (z.wassersaeule >= 5000) {
            score += 2;
            gruende.push("Hohe Wassersäule");
          }
          break;
        case "auto":
          if (z.kategorie === "dachzelt") {
            score += 10;
            gruende.push("Direkt auf dem Autodach");
          }
          break;
      }

      if (z.preis >= budgetMin && z.preis <= budgetMax) {
        score += 4;
        gruende.push("Passt ins Budget");
      } else if (answers.budget === "unter-150" && z.preis <= 200) {
        score += 1;
      } else if (answers.budget === "400-plus" && z.preis >= 300) {
        score += 2;
      }

      switch (answers.prioritaet) {
        case "gewicht":
          score += Math.max(0, 6 - z.gewicht);
          if (z.gewicht <= 2.5) gruende.push(`Nur ${z.gewicht} kg`);
          break;
        case "komfort":
          score += Math.min(5, z.hoehe / 50);
          if (z.hoehe >= 170) gruende.push("Komfortable Stehhöhe");
          if (z.kategorie === "familienzelt") score += 2;
          break;
        case "preis":
          score += Math.max(0, 5 - z.preis / 150);
          gruende.push(`Ab ${z.preis} €`);
          break;
        case "wetter":
          score += Math.min(5, z.wassersaeule / 2000);
          if (z.saison === 4) {
            score += 2;
            gruende.push("Wetterfest in 4 Jahreszeiten");
          }
          if (z.wassersaeule >= 4000) gruende.push(`${z.wassersaeule} mm Wassersäule`);
          break;
      }

      if (z.tags.includes("empfohlen") || z.tags.includes("bestseller")) {
        score += 1.5;
      }
      score += z.bewertung * 0.4;

      return { zelt: z, score, gruende: [...new Set(gruende)].slice(0, 3) };
    })
    .filter(r => r.score > 0)
    .sort((a, b) => b.score - a.score || b.zelt.bewertung - a.zelt.bewertung)
    .slice(0, limit);
}

export function sortZelte(list: Zelt[], sortBy: "preis" | "bewertung" | "name" | "personen" | "gewicht", order: "asc" | "desc" = "asc"): Zelt[] {
  return [...list].sort((a, b) => {
    let comparison = 0;
    switch (sortBy) {
      case "preis":
        comparison = a.preis - b.preis;
        break;
      case "bewertung":
        comparison = a.bewertung - b.bewertung;
        break;
      case "name":
        comparison = a.name.localeCompare(b.name);
        break;
      case "personen":
        comparison = a.personen - b.personen;
        break;
      case "gewicht":
        comparison = a.gewicht - b.gewicht;
        break;
    }
    return order === "desc" ? -comparison : comparison;
  });
}
